import Link from "next/link";

import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import ShoppingBagOutlined from "@mui/icons-material/ShoppingBagOutlined";

import useCart from "hooks/useCart";
import { useMiniCart } from "contexts/MiniCartContext";
export default function HeaderCart() {
  const {
    state
  } = useCart();
  const { setOpen } = useMiniCart();
  const quantity = state.cart.reduce((acc, item) => acc + item.qty, 0);
  return <Badge badgeContent={quantity} color="primary">
    <IconButton onClick={() => setOpen(true)}>
      <ShoppingBagOutlined sx={{
        color: "grey.600"
      }} />
    </IconButton>
  </Badge>;
}